"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BecropReport {
    constructor(biodiversity_rank, functionality_rank, resistance_rank, healthiness_rank, biocontrol_rank, hormoneprod_rank, stressadapt_rank, nutrition_c_rank, nutrition_n_rank, nutrition_p_rank, nutrition_k_rank, version) {
        this.biodiversity_rank = biodiversity_rank;
        this.functionality_rank = functionality_rank;
        this.resistance_rank = resistance_rank;
        this.healthiness_rank = healthiness_rank;
        this.biocontrol_rank = biocontrol_rank;
        this.hormoneprod_rank = hormoneprod_rank;
        this.stressadapt_rank = stressadapt_rank;
        this.nutrition_c_rank = nutrition_c_rank;
        this.nutrition_n_rank = nutrition_n_rank;
        this.nutrition_p_rank = nutrition_p_rank;
        this.nutrition_k_rank = nutrition_k_rank;
        this.version = version;
    }
    static fromJson(json) {
        return new BecropReport(json.biodiversity_rank, json.functionality_rank, json.resistance_rank, json.healthiness_rank, json.biocontrol_rank, json.hormoneprod_rank, json.stressadapt_rank, json.nutrition_c_rank, json.nutrition_n_rank, json.nutrition_p_rank, json.nutrition_k_rank, json.version);
    }
}
exports.default = BecropReport;
